type ShakaPlayerModule = typeof import('./shakaPlayer');

let pending: Promise<ShakaPlayerModule> | null = null;

/**
 * The engine, fetched when a video is actually going to be played.
 *
 * This is the app's **only** dynamic `import()`, and it is here because Shaka plus
 * `p2p-media-loader` is roughly half of everything the browser downloads and parses. Statically
 * imported it was paid for by every document, including the ones that can never play a video — and
 * Firefox hosts same-site documents on one main thread, so a new tab's parse is time the tab in
 * front is not painting. (The multi-second freeze that started this was a different bug entirely,
 * `platform/settings.ts`; this split stands on the bytes alone.)
 *
 * The promise is kept rather than the module: a second mount must not start a second import, and the
 * dock re-mounts the player on every queue advance. A rejection drops the cache, so a chunk that was
 * missing during a deploy can be asked for again instead of failing for the life of the tab.
 *
 * `sw.ts` carries the other consequence — a worker that swaps under a live page must keep the
 * previous build's chunks reachable, which is what makes `skipWaiting` still safe here.
 */
export function loadShakaPlayer(): Promise<ShakaPlayerModule> {
  pending ??= import('./shakaPlayer').catch((error: unknown) => {
    pending = null;
    throw error;
  });
  return pending;
}
